import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Credentials, LegacyLoginResponse, LoginResponse, SignupInformation } from '../../../models';
import { BackendAbstractService } from '../../abstract/backend-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class LegacyAuthBackendHandler extends BackendAbstractService<SignupInformation> {
  login(credentials: Credentials, usertype: string = 'Corporate'): Observable<LegacyLoginResponse> {
    let body = new HttpParams().set('grant_type', 'password').set('username', credentials.username).set('scope', usertype);
    if (credentials.password) {
      body = body.set('password', credentials.password);
    }
    return this.http.post<LegacyLoginResponse>(`${this.httpService.authApiUrl}token`, body);
  }

  impersonate(credentials: Credentials, usertype: string = 'Corporate'): Observable<LegacyLoginResponse> {
    return this.login(credentials, usertype);
  }

  requestPassword(email: string): Observable<null> {
    return this.http
      .get(`${this.httpService.authApiUrl}ForgotPassword`, {
        params: { email },
      })
      .pipe(map(() => null));
  }

  resetPassword(password: string, token: string): Observable<null> {
    const body = new HttpParams()
      .set('WebsiteDomain', location.hostname)
      .set('NewPassword', password)
      .set('PasswordToken', token);

    return this.http.post(`${this.httpService.authApiUrl}ResetPassword`, body).pipe(map(() => null));
  }

  signup(formData: SignupInformation): Observable<null> {
    const body = new HttpParams()
      .set('Name', formData.name)
      .set('PhoneNumber', formData.phoneNumber)
      .set('EmailAddress', formData.emailAddress)
      .set('Password', formData.password)
      .set('ReTypePassword', formData.reTypePassword)
      .set('WebsiteId', formData.websiteId.toString());
    return this.http.post(`${this.httpService.authApiUrl}Signup`, body).pipe(map(() => null));
  }

  activateAccount(confirmCode: string): Observable<null> {
    return this.http
      .get(`${this.httpService.authApiUrl}ActivateSignup`, {
        params: { id: confirmCode },
      })
      .pipe(map(() => null));
  }
}
